import React from 'react'
import PropTypes from 'prop-types'
import { joinClassList } from '../../components/utilities/utilities.js'
import '../../components/Cta/cta.css'
/**
 * Primary UI component for user interaction
 */
export const Link = ({ theme, text, href, target, icon }) => {
  const linkClasses = [
    'Link',
    'u-fontFamilyCondensed',
    'u-posRelative',
    'hover-underline-animation',
  ]
  if (theme == 'reversed') {
    linkClasses.push('Link--reversed', 'hover-underline-animation-white')
  }
  const classes = joinClassList(linkClasses)
  const iconClasses = joinClassList(['material-icons', theme])

  return (
    <div className="Cta">
      <a
        rel="noreferrer"
        className={classes}
        href={href}
        target={target == 'new_page' ? '_blank' : '_self'}
      >
        {text}
      </a>
      {icon && <i className={iconClasses}>{icon}</i>}
    </div>
  )
}

Link.propTypes = {
  text: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  target: PropTypes.oneOf(['new_page', 'same_page']),
  theme: PropTypes.oneOf(['reversed', '']),
  icon: PropTypes.string,
}
